export const V1 = 'V1';
export const HIDE_WIDGET = 'HIDE_WIDGET';